module.exports = __webpack_public_path__ + "img/bg-triangle.1fd44bdf.svg";